import React from 'react';
import { FormCommande } from 'components/organisms/forms/FormCommande';
import usePublicShop from '../../hooks/usePublicShop';
import goToPage from '../../helpers/page/goToPage';
import pages from '../../routes/pages';
import { useSelector } from 'react-redux';
import { ContainerTwoThirds } from 'components/layouts/ContainerTwoThirds';
import { getPanier } from '../../store/selectors/panier/panier.selectors';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import useStyle from './commande.style';
import emojis from 'theme/emoji';
import Panier from '../Panier';
import { ButtonWithText } from '../../components/atoms/Buttons/ButtonWithText';

const Commande = () => {
  const classes = useStyle();
  const panier = useSelector(getPanier);
  const { isPublicShop, shopId, classeId } = usePublicShop();

  const to = {
    url: isPublicShop
      ? () =>
          goToPage(pages.PUBLIC_SHOP_HOME.path, {
            shopId,
            classeId
          })
      : () => goToPage(pages.PRODUCTS_PAGE.path),
    message: isPublicShop ? "Retourner à l'accueil" : 'Revenir au magasin'
  };

  if (panier.commandeLines.length !== 0)
    return (
      <ContainerTwoThirds
        col1={<FormCommande panier={panier} />}
        col2={
          <div className={classes.root}>
            <HeaderText
              fontsize="small"
              text="Récapitulatif de votre commande"
              emoji={emojis['Package']}
            />
            <Panier />
          </div>
        }
      />
    );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '20px',
        height: '80vh'
      }}
    >
      <h2>
        Votre panier est vide{' '}
        <span role="img" aria-label="oups">
          😕
        </span>
      </h2>
      <ButtonWithText content={to.message} onClick={to.url} icon={'Pocket'} />
    </div>
  );
};

export default Commande;
